"use client";
import { createPlayer } from "../../player/create-player.js";
import { liveVideoFeatures } from "@videojs/core/dom";
//#region src/presets/live-video/player.ts
/** Preconfigured player with the live video features. */
const { Player: LiveVideoPlayer, usePlayer } = createPlayer({
	features: liveVideoFeatures,
	displayName: "LiveVideoPlayer"
});
//#endregion
export { LiveVideoPlayer, usePlayer };

//# sourceMappingURL=player.js.map